import React from "react";
import { NavLink } from "react-router-dom";
import { scrollToTop } from "../Shared/ScrollOnTop";
import StudentRightsCheck from "./StudentRightsCheck";
import { isParentPortalSession } from "./studentSupportApiPayload";

function StudentPanelMenu(props) {
  const showSupport = isParentPortalSession();
  return (
    <>
      <StudentRightsCheck />
      <nav className="navbar navbar-expand-lg navbar-module MenuSticky">
        <div className="container-fluid">
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#NavbarSecondary"
            aria-controls="NavbarSecondary"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="NavbarSecondary">
            <ul className="navbar-nav m-auto">
              <li className="nav-item">
                <NavLink
                  onClick={scrollToTop}
                  className="nav-link"
                  to="/student-panel/update-profile"
                >
                  Student Profile
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  onClick={scrollToTop}
                  className="nav-link"
                  to="/student-panel/student-ledger"
                >
                  Fee Details
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink onClick={scrollToTop} className="nav-link" to="/student-panel/exam-results">
                  Exam Results
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  onClick={scrollToTop}
                  className="nav-link"
                  to="/student-panel/student-summary"
                >
                  Attendance
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  onClick={scrollToTop}
                  className="nav-link"
                  to="/student-panel/library-books"
                >
                  Library Books
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  onClick={scrollToTop}
                  className="nav-link"
                  to="/student-panel/view-siblings">
                  View Sibling
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  onClick={scrollToTop}
                  className="nav-link"
                  to="/student-panel/class-timetable">
                  Class Time Table
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  onClick={scrollToTop}
                  className="nav-link"
                  to="/student-panel/module/students-diary">
                  Students Diary
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  onClick={scrollToTop}
                  className="nav-link"
                  to="/student-panel/events-calendar">
                  Events & Calendar
                </NavLink>
              </li>
              {showSupport ? (
              <li className="nav-item">
                <NavLink
                  onClick={scrollToTop}
                  className="nav-link"
                  to="/student-panel/support/tickets">
                  Support
                </NavLink>
              </li>
              ) : null}
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}

export default StudentPanelMenu;
